// Maison Oueslati : ajout au panier depuis les cartes maison (blog, guide, suggestions du panier).
import { CartLinesUpdateEvent, CartDiscountUpdateEvent } from '@shopify/events';
// Bouton qui applique un code depuis la jauge du panier (paliers, code de la promotion en cours).
// Défini ici et non dans le tiroir : le tiroir redessiné après un ajout n'exécute pas ses scripts.
if (!customElements.get('mo-tier-apply')) {
  customElements.define('mo-tier-apply', class extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const code = this.dataset.code;
        const deferred = CartDiscountUpdateEvent.createPromise();
        // Émis depuis document : le panier le traite comme une mise à jour externe et se redessine.
        document.dispatchEvent(new CartDiscountUpdateEvent({ discountCodes: [{ code }], promise: deferred.promise }));
        try {
          const r = await fetch(window.Shopify?.routes?.root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: code }) });
          const data = await r.json();
          deferred.resolve({ cart: CartDiscountUpdateEvent.createCartFromAjaxResponse(data) });
        } catch (e) { deferred.reject(e); btn.disabled = false; }
      });
    }
  });
}
if (!customElements.get('mo-cart-add')) {
  customElements.define('mo-cart-add', class extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('button');
      if (!btn || btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', async () => {
        btn.disabled = true;
        const id = this.dataset.variant;
        const qty = Number(this.dataset.qty || 1);
        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: id, quantity: qty }], promise: deferred.promise }));
        try {
          await fetch(window.Shopify?.routes?.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] }) });
          const cart = await fetch(window.Shopify?.routes?.root + 'cart.js').then((r) => r.json());
          deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, source: 'mo-cart-add', didError: false } });
        } catch (e) { deferred.reject(e); }
        btn.disabled = false;
      });
    }
  });
}

/* Favoris : même stockage que l'ancien thème Kalles (« t4s_wis » = « id:123,id:456 »), les clients gardent leurs favoris */
(() => {
  const KEY = 't4s_wis';
  const read = () => { try { const v = localStorage.getItem(KEY); return v ? v.split(',').map((x) => x.replace('id:', '').trim()).filter(Boolean) : []; } catch (e) { return []; } };
  const write = (ids) => { try { localStorage.setItem(KEY, ids.map((x) => 'id:' + x).join(',')); } catch (e) {} };
  const sync = () => {
    const ids = read();
    document.querySelectorAll('[data-mo-fav]').forEach((b) => {
      const on = ids.includes(b.dataset.moFav);
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    document.querySelectorAll('.mo-fav-count').forEach((c) => { c.textContent = ids.length; c.hidden = !ids.length; });
  };
  const renderList = async () => {
    const box = document.querySelector('[data-mo-fav-list]');
    if (!box) return;
    const ids = read();
    const empty = document.getElementById('mo-fav-empty');
    if (!ids.length) { box.innerHTML = empty ? empty.innerHTML : ''; return; }
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const q = ids.map((i) => 'id:' + i).join(' OR ');
    try {
      const r = await fetch(`${root}search?type=product&q=${encodeURIComponent(q)}&section_id=mo-fav-results`);
      box.innerHTML = await r.text();
      if (!box.querySelector('.mo-fav-item') && empty) box.innerHTML = empty.innerHTML;
    } catch (e) { box.innerHTML = empty ? empty.innerHTML : ''; }
    sync();
  };
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-mo-fav]');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    const id = b.dataset.moFav;
    let ids = read();
    ids = ids.includes(id) ? ids.filter((x) => x !== id) : [...ids, id];
    write(ids);
    sync();
    if (b.closest('[data-mo-fav-list]')) renderList();
  }, true);
  let t;
  new MutationObserver(() => { clearTimeout(t); t = setTimeout(sync, 150); }).observe(document.documentElement, { childList: true, subtree: true });
  window.addEventListener('storage', (e) => { if (e.key === KEY) sync(); });
  sync();
  renderList();
})();
